import "../phaser.min.js";
import Common from "../Includes/Common.js";
class FarmBackground extends Phaser.Scene {
    constructor() {
        super('FarmBackground');
        this.common = new Common();
    }

    init(data) {
        this.scrollSpeed = data.scrollSpeed;
        this.bgEvents = [
            ['moo', 'farm-animals'],
            ['moo', 'farm-animals'],
            ['moo', 'farm-animals'],
            ['exclamation', 'silos'],
            ['sixseven', 'tractor'],
            ['love', 'tomato'],
            ['happy', 'tomato'],
            ['happy', 'tomato'],
        ]
        this.eventQueue = structuredClone(this.bgEvents);
        this.readyToCreateAnimals = true;
        this.readyToCreateTomatoes = true;
    }

    preload() {
        //this.load.image('tomato', this.common.assetsPath + 'sprites/tomato.png')
    }

    create() {
        this.lights.enable();
        const light = this.lights.addLight(this.scale.width / 2, 100, 10000, 0xffffff, 1.2);

        this.coinSFX = this.sound.add('coin', {volume: 0.15});
        this.mooSFX = this.sound.add('moo', {volume: 0.1, detune: -400, rate: 1.4});
        this.tractorSFX = this.sound.add('tractor', {volume: 0.15, detune: -400});

        this.sky = this.add.tileSprite(0, 0, this.scale.width, 111, 'level', 'sky2')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale)

        this.bgTrees = this.add.tileSprite(0, 72 * this.common.gameScale, this.scale.width, 53, 'level', 'hills')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale).setLighting(true)

        this.fgTrees = this.add.tileSprite(0, 104 * this.common.gameScale, this.scale.width, 33, 'level', 'road+crops')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale).setLighting(true)

        this.crops = this.add.tileSprite(0,  this.scale.height, this.scale.width, 134, 'level', 'crops')
                .setOrigin(0, 1)
                .setScale(this.common.gameScale).setLighting(true)

        this.animals = this.add.group();
        this.tomatoes = this.add.group();

        this.addEventListeners();
    }

    update(time, delta) {
        let deltaSeconds = delta / 1000;
        this.sky.tilePositionX += this.scrollSpeed * 0.05 * deltaSeconds;
        this.bgTrees.tilePositionX += this.scrollSpeed * 0.75 * deltaSeconds;
        this.fgTrees.tilePositionX += this.scrollSpeed * deltaSeconds;
        this.crops.tilePositionX += this.scrollSpeed * 1.2 * deltaSeconds;

        if(this.animals) {
            let children = this.animals.getChildren();
            let odd = true;
            for(let child of children) {
                child.x -= (this.common.gameScale * this.scrollSpeed * 0.75 * deltaSeconds);
                if (child.x < -100 * this.common.gameScale) {
                    child.x = this.scale.width * 1.2;
                }
                odd = !odd;
            }
        }

        if(this.tomatoes) {
            let children = this.tomatoes.getChildren();
            let odd = true;
            for(let child of children) {
                child.x -= (this.common.gameScale * this.scrollSpeed * 1.2 * deltaSeconds);
                if (child.x < -100 * 2) {
                    child.x = this.scale.width * 1.2;
                }
                odd = !odd;
            }
        }

        if(this.silos) {
            this.silos.x -= (this.common.gameScale * this.scrollSpeed * 0.75 * deltaSeconds);
            if(this.silos.x < -200 * this.common.gameScale) {
                this.silos.x = this.scale.width * 1.25;
            }
        }

        if(this.tractor) {
            this.tractor.x -= (this.common.gameScale * this.scrollSpeed * 0.75 * deltaSeconds);
            if(this.tractor.x < -200 * this.common.gameScale) {
                this.tractor.x = this.scale.width * 1.2;
            }
        }
    }

    onSceneWake() {
        this.bgEvents = structuredClone(this.eventQueue);
        this.readyToCreateAnimals = true;
        this.addEventListeners();
    }

    quizEventHandler() {
        const quiz = this.scene.get('Quiz');
        quiz.events.on('scroll-speed-changed', (data) => {
            this.scrollSpeed = data.scrollSpeed;
        }, this)

        quiz.events.on('resetQuestion', () => {
            this.readyToCreateAnimals = true;
            this.readyToCreateTomatoes = true;
        }, this)

        quiz.events.on('reset', () => {
            if(this.animals) {
                this.animals.getChildren().forEach(animal => {
                    animal.destroy();
                })
            }
            if(this.tomatoes) {
                this.tomatoes.getChildren().forEach(tomato => {
                    tomato.destroy();
                })
            }
            if(this.silos) {
                this.silos.destroy();
            }
            if(this.tractor) {
                this.tractor.destroy();
            }

            this.readyToCreateAnimals = true;
            this.readyToCreateTomatoes = true;
            this.bgEvents = structuredClone(this.eventQueue);
        })
    }

    carEventHandler = () => {
        this.car = this.scene.get('Car')
        this.events.on('love', () => {
            this.car.showEmote('heart-emote')
        }, this)

        this.events.on('happy', () => {
            this.car.showEmote('happy-emote')
        }, this)

        this.events.on('sixseven', () => {
            this.car.showEmote('67-emote')
        }, this)

        this.events.on('bigfoot', ()=>{
            this.sasquatch.x = this.scale.width + 40;
            this.sasquatch.setVisible(true);
            this.car.showEmote('bigfoot-emote')
        }, this)

        this.events.on('exclamation', ()=>{
            this.car.showEmote('exclamation-emote')
        })

        this.events.on('moo', () =>  {
            this.car.showEmote('moo-emote')
        })
        this.events.on('bruh', () => {
            this.car.showEmote('bruh-emote')
        })
    }

    addEventListeners() {
        if(this.scene.get('Quiz')) {
            this.quizEventHandler();
        }

        if(this.scene.get('Car')) {
            this.carEventHandler();
        }

        this.events.on('tomato', () => {
            if(!this.readyToCreateTomatoes) return;
            const min = this.scale.height/12 * 7.5;
            const max = this.scale.height/12 * 11.8;
            const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
            this.newTomato = this.tomatoes.create(this.scale.width * 0.95, randomNumber, 'level', 'tomato')
                    .setOrigin(0.5, 1).setScale(0).setDepth(2)
            this.tweens.chain({
                targets: this.newTomato,
                tweens: [
                    {
                        y: randomNumber,
                        scaleY: 4.4,
                        scaleX: 3,
                        duration: 100,
                        ease: 'Power2'
                    },
                    {
                        scaleY: 4,
                        scaleX: 4,
                        duration: 150,
                        ease: 'Back.easeOut'
                    }
                ]
            })
            this.readyToCreateTomatoes = false;
        })

        this.events.on('farm-animals', ()=>{
            if(!this.readyToCreateAnimals) return;
            this.mooSFX.play();
            this.newAnimal = this.animals.create(this.scale.width * 0.75, this.scale.height/12 * 4.6 + 48, 'level', 'new-cows')
                    .setOrigin(0.5, 1).setScale(this.common.gameScale).setDepth(2)
            this.tweens.chain({
                targets: this.newAnimal,
                tweens: this.common.popUpTweenChain(this.scale.height/12 * 4.6)
            })
            this.readyToCreateAnimals = false;
        }, this)

        this.events.on('silos', ()=>{
            this.coinSFX.play();
            this.silos = this.add.sprite(this.scale.width * 0.75, this.scale.height/12 * 4.25 + 100, 'level', 'silos')
                    .setOrigin(0.5, 1)
                    .setScale(0)
                    .setDepth(1)
            this.tweens.chain({
                targets: this.silos,
                tweens: this.common.popUpTweenChain(this.scale.height/12 * 4.25)
            });
        }, this)

        this.events.on('tractor', ()=>{
            this.tractor = this.add.sprite(this.scale.width * 0.75, this.scale.height/12 * 4.25 + 80, 'level', 'tractor')
                    .setOrigin(0.5, 1)
                    .setScale(0)
                    .setDepth(3)
            this.tweens.chain({
                targets: this.tractor,
                tweens: this.common.popUpTweenChain(this.scale.height/12 * 4.25 + 50)
            });
            this.tractorSFX.play({loop: true});
            this.tweens.add({
                targets: this.tractorSFX,
                volume: 0,
                duration: 100,
                delay: 2000,
                onComplete: () => {
                    this.tractorSFX.stop();
                }
            })
        })


        const backgroundManager = this.scene.get('BackgroundManager');
        backgroundManager.events.on('FarmBackground-fire-background-event', () => {
            let bgEvent = this.bgEvents.pop();
            if(Array.isArray(bgEvent)) {
                bgEvent.forEach(event => {
                    this.events.emit(event);
                })
            }else{
                this.events.emit(bgEvent);
            }
        }, this)
        backgroundManager.events.on('FarmBackground-fade-out', () => {
            this.add.tween({
                targets: this.animals.getChildren(),
                alpha: 0,
                duration: 2000,
                ease: 'Linear',
                yoyo: false,
                repeat: 0,
            })
            this.add.tween({
                targets: this.tomatoes.getChildren(),
                alpha: 0,
                duration: 2000,
                ease: 'Linear',
                yoyo: false,
                repeat: 0,
            })
            this.add.tween({
                targets: [this.sky, this.bgTrees, this.fgTrees, this.crops, this.silos, this.tractor],
                alpha: 0,
                duration: 2000,
                ease: 'Linear',
                yoyo: false,
                repeat: 0,
                onComplete: () => {
                    this.scene.sleep(this)
                }
            })
        }, this)

        this.events.on('wake', this.onSceneWake, this);
    }
}

export default FarmBackground;